export const assets = {
    logoSrc: require('@/new-assets/logo-horizontal-white.svg'),
    emailIconSrc: require('@/new-assets/icons/mail-icon.svg'),
    phoneIconSrc: require('@/new-assets/icons/phone-icon.svg'),
    locationIconSrc: require('@/new-assets/icons/location-icon.svg'),
    logoVerticalSrc: require('@/new-assets/logo-vertical.svg'),
    logoHorizontalSrc: require('@/new-assets/logo-horizontal.svg'),
    bannerBackgroundSrc: require('@/new-assets/banner-background.png'),
    searchIconSrc: require('@/new-assets/icons/search-icon.svg'),
};